<template>
  <el-container>
    <el-header height="">
      <el-container>
        <el-aside width="200px">
          <h1 style="font-size: 1.5em;">Sha256.cc</h1>
        </el-aside>
        <el-main style="padding:25px">
          <tabs v-bind="tabs"></tabs>
        </el-main>
      </el-container>
    </el-header>
    <el-card>
      <el-container>
        <el-aside width="200px" id="sidebar">
          <side-bar v-bind:index.sync="sidebar.index" v-bind:menus="sidebar.menus"></side-bar>
        </el-aside>
        <el-main v-if="iframeSrc" class="iframeContainer">
          <iframe-view v-bind:src="iframeSrc"></iframe-view>
        </el-main>
        <el-main v-else>
          <keep-alive>
            <component v-bind:is="currentComponent">暂未实现</component>
          </keep-alive>
        </el-main>
      </el-container>
    </el-card>
  </el-container>
</template>

<script>
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import { HeadTabs, SiderBarMenus } from "@/utils.js";
import IframeView from './IframeView.vue';

export default {
  components: { IframeView },
  name: "baseview",
  data() {
    return {
      tabs: {
        active: this.activeTab,
        tabs: HeadTabs
      },
      sidebar: {
        index: SiderBarMenus[this.activeTab].default,
        menus: SiderBarMenus[this.activeTab].menu
      }
    };
  },
  props: {
    activeTab: String,
    requiredComponents: Object
  },
  computed: {
    // 如果页面菜单配置了iframe属性，则直接以iframe-view进行渲染
    iframeSrc: function() {
      let src = null;
      this.sidebar.menus.forEach(group => {
        group.menus.forEach(m => {
          if (m.id == this.sidebar.index) {
            src = m.iframe
          }
        });
      });
      return src;
    },
    currentComponent: function() {
      let name = upperFirst(camelCase(this.activeTab + this.sidebar.index));
      // if (name in this.$root.$options.components) {
      //   return this.$root.$options.components[name];
      // }
      return name;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #sidebar {
    height: 80vh;
  }

  .iframeContainer {
    overflow: hidden;
  }
</style>
